export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/referral_program_perseus/header_xl.91139dd.png";